// ----------------------------------------------------------------------

const MuiTypography = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {}
}

// ----------------------------------------------------------------------

export const typography = { MuiTypography }
